import { useState } from 'react'
import Alert from '@mui/material/Alert'
import CircularProgress from '@mui/material/CircularProgress'
import Popover from '@mui/material/Popover'
import makeStyles from '@mui/styles/makeStyles'
import { useSelector } from 'react-redux'
import { useDatasetDataContext } from '@datasets/dataset-details/datasetData/context'
import { CellHistory } from './CellHistory'
import { api } from 'api'
import { t } from '@lingui/core/macro'

const useStyles = makeStyles(() => ({
  contentWrapper: {
    width: 350,
  },
  progressWrapper: {
    padding: 48,
    textAlign: 'center',
  },
}))

export function CellHistoryPopover({ column, rowData, open, anchorEl, handlePopoverClose }) {
  const [loadingError, setLoadingError] = useState(false)
  const [loading, setLoading] = useState(null)
  const [history, setCellHistory] = useState(null)
  const { datasetDataId } = useDatasetDataContext()
  const dataset = useSelector(state => state.Datasets.datasetMetadataById[datasetDataId])

  const handlePopoverOpen = () => {
    const { fieldId } = column
    const cvId = rowData.cvid

    const datasetId = dataset && dataset.id
    if (!datasetId) {
      setLoadingError(true)
      return
    }

    setLoading(true)
    api
      .get(`/api/v1/account/dataset/${datasetId}/data/${cvId}/${fieldId}/history`)
      .then(response => {
        setCellHistory(response.data)
        setLoading(false)
      })
      .catch(() => {
        setLoadingError(true)
        setLoading(false)
      })
  }

  const classes = useStyles()

  return (
    <>
      {open && (
        <Popover
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 32,
          }}
          onClose={handlePopoverClose}
          disableRestoreFocus
          TransitionProps={{
            onEnter: handlePopoverOpen,
          }}
        >
          <div className={classes.contentWrapper}>
            {!loading && loadingError && (
              <div className={classes.progressWrapper}>
                <Alert severity="info">
                  {t`We were unable to load your cell history. Please try again later.`}
                </Alert>
              </div>
            )}
            {loading && !loadingError && (
              <div className={classes.progressWrapper}>
                <CircularProgress />
              </div>
            )}
            {!loading && !loadingError && <CellHistory cellHistory={history} />}
          </div>
        </Popover>
      )}
    </>
  )
}
